var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var require_src = __commonJS({
  "src/index.ts"(exports, module) {
    function isBlocking(node) {
      return node.nodeType === Node.ELEMENT_NODE && (node.tagName === "SCRIPT" && node.src && !(node.noModule || node.type === "module" || node.hasAttribute("async") || node.hasAttribute("defer")) || node.tagName === "LINK" && node.rel === "stylesheet" && (!node.media || matchMedia(node.media).matches));
    }
    function getPreloadLink(node) {
      let link;
      if (node.nodeType === Node.ELEMENT_NODE) {
        switch (node.tagName) {
          case "SCRIPT":
            if (node.src && !node.noModule) {
              link = document.createElement("link");
              link.href = node.src;
              if (node.getAttribute("type") === "module") {
                link.rel = "modulepreload";
              } else {
                link.rel = "preload";
                link.as = "script";
              }
            }
            break;
          case "LINK":
            if (node.rel === "stylesheet" && (!node.media || matchMedia(node.media).matches)) {
              link = document.createElement("link");
              link.href = node.href;
              link.rel = "preload";
              link.as = "style";
            }
            break;
          case "IMG":
            link = document.createElement("link");
            link.rel = "preload";
            link.as = "image";
            if (node.srcset) {
              link.imageSrcset = node.srcset;
              link.imageSizes = node.sizes;
            } else {
              link.href = node.src;
            }
            break;
        }
        if (link) {
          if (node.integrity) {
            link.integrity = node.integrity;
          }
          if (node.crossOrigin) {
            link.crossOrigin = node.crossOrigin;
          }
        }
      }
      return link;
    }
    module.exports = function writableDOM(target, previousSibling) {
      if (this instanceof writableDOM) {
        return new WritableStream(writableDOM(target, previousSibling));
      }
      const doc = document.implementation.createHTMLDocument("");
      doc.write("<!DOCTYPE html><body><template>");
      const root = doc.body.firstChild.content;
      const walker = doc.createTreeWalker(root);
      const targetNodes = new WeakMap([[root, target]]);
      const nextSibling = previousSibling ? previousSibling.nextSibling : null;
      let pendingText = null;
      let scanNode = null;
      let resolve;
      let isBlocked = false;
      return {
        write(chunk) {
          doc.write(chunk);
          if (pendingText) {
            targetNodes.get(pendingText).data = pendingText.data;
          }
          walk();
        },
        abort() {
          if (isBlocked) {
            targetNodes.get(walker.currentNode).remove();
          }
        },
        close() {
          return isBlocked ? new Promise((_) => resolve = _) : Promise.resolve();
        }
      };
      function walk() {
        let node;
        if (isBlocked) {
          const blockedNode = walker.currentNode;
          if (scanNode)
            walker.currentNode = scanNode;
          while (node = walker.nextNode()) {
            const link = getPreloadLink(scanNode = node);
            if (link) {
              link.onload = link.onerror = () => target.removeChild(link);
              target.insertBefore(link, nextSibling);
            }
          }
          walker.currentNode = blockedNode;
        } else {
          while (node = walker.nextNode()) {
            const clone = document.importNode(node, false);
            if (node.nodeType === Node.TEXT_NODE) {
              pendingText = node;
            } else {
              pendingText = null;
              if (isBlocking(clone)) {
                isBlocked = true;
                clone.onload = clone.onerror = () => {
                  isBlocked = false;
                  if (clone.parentNode)
                    walk();
                };
              }
            }
            const parentNode = targetNodes.get(node.parentNode);
            targetNodes.set(node, clone);
            if (parentNode === target) {
              target.insertBefore(clone, nextSibling);
            } else {
              parentNode.appendChild(clone);
            }
            if (isBlocked)
              return walk();
          }
          if (resolve)
            resolve();
        }
      }
    };
  }
});
export default require_src();
